import Alpine from "alpinejs";
import Splide from "@splidejs/splide";

document.addEventListener("alpine:init", () => {
  Alpine.data("categoriesSlider", (perPage = 4) => ({
    currentSlide: 1,
    init() {
      const slider = new Splide(this.$refs.categoriesSliderRef, {
        perPage: 1,
        gap: 40,
        loop: true,
        pagination: false,
        mediaQuery: "min",
        breakpoints: {
          992: {
            perPage: perPage,
          },
          768: {
            perPage: perPage - 1,
          },
          576: {
            perPage: 2,
          },
        },
      });
      slider.on("move", (newIndex) => (this.currentSlide = newIndex + 1));
      slider.on("overflow", (isOverflow) => {
        console.info("isOverflow", isOverflow);
      });
      slider.mount();
    },
  }));
});
